import {
  NODE_CARD_EMPHASIS_DIMMED,
  NODE_CARD_EMPHASIS_HIGHLIGHTED,
  type NodeCardEmphasis,
} from '@aibuild/ui';

export interface ConnectionFocus {
  readonly nodeIds: ReadonlySet<string>;
  readonly edgeIds: ReadonlySet<string>;
}

interface FocusEdge {
  readonly id: string;
  readonly source: string;
  readonly target: string;
}

export function buildConnectionFocus(
  selectedNodeIds: readonly string[],
  edges: readonly FocusEdge[],
): ConnectionFocus | null {
  if (selectedNodeIds.length === 0) return null;
  const selected = new Set(selectedNodeIds);
  const nodeIds = new Set<string>();
  const edgeIds = new Set<string>();
  for (const edge of edges) {
    if (!selected.has(edge.source) && !selected.has(edge.target)) continue;
    edgeIds.add(edge.id);
    nodeIds.add(edge.source);
    nodeIds.add(edge.target);
  }
  if (edgeIds.size === 0) return null;
  for (const id of selected) nodeIds.add(id);
  return { nodeIds, edgeIds };
}

const emphasisFor = (
  ids: ReadonlySet<string> | undefined,
  id: string,
): NodeCardEmphasis | null => {
  if (!ids) return null;
  return ids.has(id) ? NODE_CARD_EMPHASIS_HIGHLIGHTED : NODE_CARD_EMPHASIS_DIMMED;
};

export const nodeEmphasisFor = (
  focus: ConnectionFocus | null | undefined,
  nodeId: string,
): NodeCardEmphasis | null => emphasisFor(focus?.nodeIds, nodeId);

export const edgeEmphasisFor = (
  focus: ConnectionFocus | null | undefined,
  edgeId: string,
): NodeCardEmphasis | null => emphasisFor(focus?.edgeIds, edgeId);
